<template>
  <div id="app">
    <router-view />

    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import Footer from "@/components/footer/footer.vue";
import {
  randomImage,
  getPhoneCode,
  webPhoneLogin,
  wdLoginRecord,
  resetPasswordFunc,
  webPasswordLogin,
} from "@/api/login.js";
export default {
  name: "App",
  // components: {Footer},
  created() {
    let token = window.localStorage.getItem("token");

    if (token) {
      wdLoginRecord();
    }

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        // 离开当前tab标签
        console.log("离开当前tab标签");
        // 暂停视频
      } else {
        let token = window.localStorage.getItem("token");

        if (token) {
          wdLoginRecord();
        }

        // 播放视频
        console.log("回到当前tab标签");
      }
    });
    // console.log(this.$route)
  },
};
</script>

<style>
@import url("./css/elRest.css");
html,
body,
ul,
li,
ol,
dl,
dd,
dt,
p,
h1,
h2,
h3,
h4,
h5,
h6,
form,
fieldset,
legend,
img,
div {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
fieldset,
img,
input,
button {
  border: none;
  padding: 0;
  margin: 0;
  outline-style: none;
}
ul,
ol {
  list-style: none;
}
.portions {
  position: fixed;
  right: 30px;
  bottom: 0px;
  z-index: 9999;
}
input {
  padding-top: 0;
  padding-bottom: 0;
  font-family: "SimSun", "宋体";
}
select,
input {
  vertical-align: middle;
}
select,
input,
textarea {
  font-size: 12px;
  margin: 0;
}
textarea {
  resize: none;
}
img {
  border: 0;
  vertical-align: middle;
}
table {
  border-collapse: collapse;
}
body {
  font: 14px/150% Microsoft, YaHei, "\5b8b\4f53";
  color: #333333;
  background: #eff1f4 !important;
}
.clearfix::after {
  content: "";
  display: block;
  clear: both;
}
.clearfix {
  zoom: 1;
} /*IE/7/6*/
a {
  text-decoration: none;
  box-sizing: border-box;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-decoration: none;
  font-weight: normal;
}
s,
i,
em {
  font-style: normal;
  text-decoration: none;
}
body {
  min-width: 1366px !important;
  font-family: Microsoft YaHei !important;
}

/*公共类*/
.w1290 {
  width: 1290px;
  margin: 0 auto;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.al {
  text-align: left;
}
.ac {
  text-align: center;
}
.ar {
  text-align: right;
}
.hide {
  display: none;
}
.mt30 {
  margin-top: 30px;
}
.mb40 {
  margin-bottom: 40px;
}
.cursor {
  cursor: pointer;
}

/* 超出两行省略多余 */
.pass_2line_hidden {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
/* 超出1行省略多余 */
.pass_1line_hidden {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/App.vue